/**
 * Login Page
 * Google OAuth login for GENESIS
 */

import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { LoadingSpinner } from './ui';

export function LoginPage() {
  const { login, isLoading } = useAuth();
  const [error, setError] = useState<string | null>(null);

  // Check for error in URL params
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const errorParam = params.get('error');

    if (errorParam) {
      switch (errorParam) {
        case 'oauth_denied':
          setError('Acceso denegado. Por favor, permite el acceso para continuar.');
          break;
        case 'no_code':
          setError('Error de autenticación. Inténtalo de nuevo.');
          break;
        case 'auth_failed':
          setError('Error al iniciar sesión. Inténtalo de nuevo.');
          break;
        default:
          setError('Error desconocido. Inténtalo de nuevo.');
      }
      // Clean URL
      window.history.replaceState({}, '', '/login');
    }
  }, []);

  if (isLoading) {
    return (
      <div className="login-page">
        <div className="login-container">
          <div className="login-loading">
            <LoadingSpinner text="Cargando..." />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1 className="login-title">GENESIS</h1>
          <p className="login-subtitle">Simulador de Vida Artificial</p>
        </div>

        <div className="login-content">
          <div className="login-description">
            <p>Crea y guía tu propia criatura en un mundo compartido.</p>
            <p>Compite con otros jugadores para sobrevivir y evolucionar.</p>
          </div>

          {error && (
            <div className="login-error">
              <span className="error-icon">!</span>
              <span>{error}</span>
            </div>
          )}

          <button className="login-button google" onClick={login}>
            <svg className="google-icon" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="currentColor"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="currentColor"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="currentColor"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            <span>Iniciar sesión con Google</span>
          </button>
        </div>

        <div className="login-features">
          <div className="feature">
            <span className="feature-icon">🧬</span>
            <span>Criaturas con redes neuronales</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🌍</span>
            <span>Mundo compartido en tiempo real</span>
          </div>
          <div className="feature">
            <span className="feature-icon">🏆</span>
            <span>Compite en el leaderboard</span>
          </div>
        </div>

        <div className="login-footer">
          <p>GENESIS v0.2.0</p>
        </div>
      </div>
    </div>
  );
}
